<!--婴幼儿管理-->
<template>
  <div class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px">筛选搜索</span>
      </div>
    </div>
    <el-card shadow="never" style="margin-top: 0px">
      <div style="margin-top: 10px">
        <el-form
          ref="queryForm"
          :inline="true"
          :model="queryParam"
          label-width="140px"
        >
          <el-form-item label="家长手机号:" prop="mobilePhone">
            <el-input
              v-model="queryParam.mobilePhone"
              placeholder="输入手机号"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="家长姓名:">
            <el-input
              v-model="queryParam.inputUserName"
              placeholder="输入姓名"
              style="width: 200px"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="会员姓名:" prop="childName">
            <el-input
              v-model="queryParam.childName"
              placeholder="输入姓名"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="孩子小名:" prop="childNickName">
            <el-input
              v-model="queryParam.childNickName"
              placeholder="输入小名"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="日期" prop="registerDate">
            <el-date-picker
              v-model="queryParam.registerDate"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="跟进人" prop="follower">
            <el-select
              v-model="queryParam.follower"
              placeholder="选择跟进人"
              @change="getList"
              clearable=""
              style="width: 200px"

            >
              <el-option
                v-for="item in workersList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="已使用课时:" v-if="queryParam.type ==1">
            <el-input-number
              v-model="queryParam.usedClass"
              placeholder="体验卡已使用课时"
            ></el-input-number>
          </el-form-item>  -->
          <el-form-item>
            <el-button
              type="warning"
              size="medium"
              class="operator-btn2"
              icon="el-icon-refresh"
              @click="handleResetSearch()"
              >重 置</el-button
            >
            <el-button
              type="primary"
              size="medium"
              class="operator-btn"
              icon="el-icon-search"
              @click="onBtnSearch()"
              >查 询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <!-- <div class="title-container" shadow="never" style="margin-top: 20px">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px">数据列表</span>
      </div>
      <div>
        <el-button
          type="danger"
          size="medium"
          class="operator-btn3"
          style="width: 120px"
          icon="el-icon-guide"
          @click="handleAddClueDig()"
          >创建线索</el-button
        >
      </div>
    </div> -->
    <div class="table-container" style="margin-top: 20px">
      <div class="d-flex jc-between ai-center manage-btn">
        <div class="tab-box">
          <div
            class="tab-box-item"
            :class="queryParam.type == item.type ? 'tab-box-item-checked' : ''"
            v-for="(item, index) in tabsList"
            :key="index"
            @click="handleTab(item.type)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="d-flex">
          <el-button
            type="primary"
            size="medium"
            class="operator-btn"
            icon="el-icon-setting"
            @click="handleSetting()"
            >参数设置</el-button
          >
          <el-button
            type="primary"
            size="medium"
            class="operator-btn"
            icon="el-icon-eleme"
            @click="handleFollow()"
            >跟进</el-button
          >
          <div class="spec-buton-box">
            <el-button
              type="primary"
              size="medium"
              class="operator-btn"
              icon="el-icon-upload"
              @click="handleFileUpload()"
              >营销数据导入</el-button
            >
            <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
          </div>
          <div class="spec-buton-box">
            <el-button
              type="primary"
              size="medium"
              class="operator-btn"
              icon="el-icon-eleme"
              @click="handleMoreFollow()"
              >批量替换</el-button
            >
            <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
          </div>
          <div class="spec-buton-box">
            <el-button
              type="primary"
              size="medium"
              class="operator-btn"
              icon="el-icon-s-help"
              @click="handleFollowArrange()"
              >跟进安排</el-button
            >
            <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
          </div>
        </div>
      </div>
      <!-- @row-click="rowClick" -->
      <el-table
        v-if="queryParam.type != 2"
        key="stateOne"
        ref="clientTable"
        style="width: 100%"
        :data="tableData"
        max-height="540"
        v-loading="listLoading"
        :row-class-name="tableRowClassName"
        border
        highlight-current-row
        :span-method="objectSpanMethod"
        @select="handleSelectionChange"
        :header-cell-style="{
          'text-align': 'center',
          background: '#edf3fe',
          color: '#0d6fb8',
        }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <!-- <el-table-column
          prop="userName"
          label="客户姓名"
          width="140"
        ></el-table-column> -->
        <el-table-column
          prop="mobilePhone"
          label="手机号"
          width="140"
        ></el-table-column>
        <el-table-column label="会员姓名" prop="childName"></el-table-column>
        <el-table-column prop="gender" label="孩子性别"></el-table-column>
        <el-table-column
          prop="birthday"
          label="出生日期"
          width="120"
        ></el-table-column>
        <el-table-column label="孩子小名" prop="nickName"></el-table-column>
        <el-table-column prop="channel" label="渠道"></el-table-column>
        <el-table-column prop="source" label="来源"></el-table-column>

        <el-table-column
          prop="address"
          label="居住地址(小区)"
          :show-overflow-tooltip="true"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="registerDate"
          label="创建日期"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="createDateTime"
          label="跟进创建日期"
          width="160"
        ></el-table-column>
        <el-table-column prop="intentionLevel" label="意向级别">
          <template slot-scope="{ row }">
            {{ getCurrentStage(row.intentionLevel, "intentionLevel") }}
          </template>
        </el-table-column>
        <el-table-column prop="workers" label="跟进人">
          <template slot-scope="{ row }">
            <!-- {{ row.workers }} -->
            {{ getWorkersVal(row.workers) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="followState" label="跟进意向">
          <template slot-scope="{ row }">
            {{ getCurrentStage(row.followState, "followState") }}
          </template>
        </el-table-column> -->
        <el-table-column prop="currentStage" label="跟进阶段">
          <template slot-scope="{ row }">
            {{ getCurrentStage(row.currentStage, "currentStage") }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="childMonth" label="孩子月龄"></el-table-column> -->

        <el-table-column prop="userRemark" label="备注"></el-table-column>
        <!-- <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small">详情</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-table
        v-else
        key="stateTwo"
        ref="clientTable"
        style="width: 100%"
        :data="tableData"
        max-height="540"
        v-loading="listLoading"
        :row-class-name="tableRowClassName"
        border
        highlight-current-row
        @select="handleSelectionChange"
        :header-cell-style="{
          'text-align': 'center',
          background: '#edf3fe',
          color: '#0d6fb8',
        }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="会员姓名" prop="childName"></el-table-column>
        <el-table-column
          prop="mobilePhone"
          label="手机号"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="createDateTime"
          label="跟进创建日期"
        ></el-table-column>
        <el-table-column prop="userRemark" label="备注"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage"
      >
      </el-pagination>
    </div>

    <!--    添加线索-->
    <el-dialog
      title="添加线索"
      :visible.sync="visibleDlgAddClue"
      width="50%"
      center
    >
      <create-cule
        :info="clueInfo"
        :all-worker="allWorker"
        @onCreateSuccess="onCreateClueSuccess"
      ></create-cule>
    </el-dialog>

    <!-- 参数设置 -->
    <el-dialog
      :visible.sync="visibleParameterSetting"
      title="参数设置"
      width="30%"
      center
    >
      <el-form ref="settingForm" :model="settingForm" label-width="170px">
        <el-form-item label="默认下次跟进间隔天数">
          <el-input
            type="number"
            v-model="settingForm.shortTermClientFollowDay"
          ></el-input>
        </el-form-item>
        <el-form-item label="L F">
          <el-input v-model="settingForm.longTermClientFollowDay"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave">保 存</el-button>
        <el-button @click="visibleParameterSetting = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 跟进按钮弹窗 -->
    <el-dialog :visible.sync="visibleFollow" title="跟进" width="800px" center>
      <div>
        <!-- 客户列表跟进 -->
        <clientFollow
          v-if="queryParam.type == 1 || queryParam.type == 2"
          ref="clientPageFollowRef"
          :clientInfo="clientAllData"
          :masterId="masterId"
          :currentBelong="queryParam.type"
        ></clientFollow>
        <!-- 会员跟进 -->
        <!-- <vipFollowVue></vipFollowVue> -->
        <!-- 数据导入跟进 -->
        <!-- <dataImportFollow v-else-if="queryParam.type == 3"></dataImportFollow> -->
        <user-child-detail
          @onBtnCreate="handleOnBtnCreate"
          v-else-if="queryParam.type == 3"
          :key="addRefresh"
          :clientData="checkedData"
        >
          <!-- :store-lesson-exp-cards="storeLessonEXPCards"
          @onBtnCreate="onBtnCreate"
          @onBtnCancel="onBtnCancel" -->
        </user-child-detail>
      </div>
      <div slot="footer" class="dialog-footer" v-if="queryParam.type != 3">
        <el-button type="primary" @click="handleFollowSave">保 存</el-button>
        <el-button @click="visibleFollow = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 批量替换弹窗 -->
    <el-dialog
      :visible.sync="visibleMoreFollow"
      title="跟进安排"
      width="600px"
      center
    >
      <div>
        <el-form
          ref="moreFollowForm"
          :model="moreFollowForm"
          label-width="120px"
          :rules="moreFormRules"
        >
          <el-row>
            <el-col>
              <el-form-item label="当前跟进人">
                <el-select
                  disabled
                  v-model="queryParam.follower"
                  placeholder="选择跟进人"
                >
                  <el-option
                    v-for="item in workersList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              v-for="(cur, curIx) in moreFollowForm.targetWorkerList"
              :key="curIx"
            >
              <el-form-item label="跟换跟进人:">
                <!-- :prop="'targetWorkerList.' + curIx + '.workerId'"
                :rules="moreFormRules.adName" -->
                <el-select
                  filterable=""
                  v-model="cur.workerId"
                  placeholder="请选择"
                  clearable=""
                >
                  <el-option
                    v-for="item in workersList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="
                      cur.workerId == item.id ||
                      moreFollowForm.targetWorkerList
                        .map((mk) => {
                          return Number(mk.workerId);
                        })
                        .includes(item.id)
                        ? true
                        : false
                    "
                  >
                  </el-option>
                </el-select>
                <i
                  v-if="moreFollowForm.targetWorkerList.length - 1 == curIx"
                  class="el-icon-circle-plus"
                  style="font-size: 20px; cursor: pointer"
                  @click="handleAddPerson"
                ></i>
                <i
                  v-if="moreFollowForm.targetWorkerList.length > 1"
                  class="el-icon-remove"
                  style="font-size: 20px; cursor: pointer; margin-left: 15px"
                  @click="handleDelPerson(curIx)"
                ></i>
              </el-form-item>
            </el-col>
            <!-- <el-col>
              <el-form-item label="更换跟进人">
                <el-transfer
                  v-model="moreFollowForm.targetWorkerList"
                  :data="workersList"
                  :props="{
                    key: 'id',
                    label: 'name',
                  }"
                ></el-transfer>
              </el-form-item>
            </el-col> -->
          </el-row>
          <!-- <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="跟进时间期限">
                <el-date-picker
                  v-model="moreFollowForm.name"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleMoreFollowSave"
          >保 存</el-button
        >
        <el-button @click="visibleMoreFollow = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 营销数据导入 -->
    <el-dialog
      title="营销数据导入"
      :visible.sync="visibleFileupload"
      width="800px"
      center
    >
      <div v-if="isUploadBtn">
        <el-button
          @click="handleDownload"
          type="primary"
          size="medium"
          style="margin-bottom: 20px"
          >下载模板</el-button
        >
        <el-upload
          ref="uploadFile"
          :limit="1"
          accept=".xlsx, .xls"
          :headers="importHeaders"
          :action="uploadUrl"
          :on-success="handleFileSuccess"
          :auto-upload="true"
          drag
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </div>
      <div v-else>
        <el-card shadow="always" style="margin-bottom: 20px">
          <el-row>
            <el-col :span="8">
              数量 : {{ fileSuccessData.count ? fileSuccessData.count : 0 }}
            </el-col>
            <el-col :span="8">
              失败数量 :
              {{ fileSuccessData.errorCount ? fileSuccessData.errorCount : 0 }}
            </el-col>
            <el-col :span="8">
              成功数量 :
              {{
                fileSuccessData.successCount ? fileSuccessData.successCount : 0
              }}
            </el-col>
          </el-row>
        </el-card>
        <!-- <el-form
          style="margin-top: 10px"
          ref="form"
          :model="fileSuccessData"
          label-width="80px"
        >
          <el-form-item label="数量">
            <el-input disabled v-model="fileSuccessData.count"></el-input>
          </el-form-item>
          <el-form-item label="失败数量">
            <el-input disabled v-model="fileSuccessData.errorCount"></el-input>
          </el-form-item>
          <el-form-item label="成功数量">
            <el-input
              disabled
              v-model="fileSuccessData.successCount"
            ></el-input>
          </el-form-item>
        </el-form> -->
        <div
          v-if="
            fileSuccessData &&
            fileSuccessData.success &&
            fileSuccessData.success.length
          "
        >
          <div>成功结果</div>
          <el-table
            max-height="300"
            ref="fileTable"
            :data="fileSuccessData.success"
          >
            <el-table-column
              label="会员姓名"
              prop="childrenName"
            ></el-table-column>
            <el-table-column
              label="手机号码"
              prop="mobilePhone"
            ></el-table-column>
            <el-table-column label="备注信息" prop="remark"></el-table-column>
          </el-table>
        </div>
        <div
          v-if="
            fileSuccessData &&
            fileSuccessData.error &&
            fileSuccessData.error.length
          "
        >
          <div>失败结果</div>
          <el-table
            max-height="300"
            ref="fileTable"
            :data="fileSuccessData.error"
          >
            <el-table-column
              label="会员姓名"
              prop="childrenName"
            ></el-table-column>
            <el-table-column
              label="手机号码"
              prop="mobilePhone"
            ></el-table-column>
            <el-table-column label="备注信息" prop="remark"></el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleRefershFile">确 定</el-button>
        <el-button @click="visibleFileupload = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 选择客户跟进数据弹窗 -->
    <el-dialog
      :visible.sync="visibleClientFollow"
      title="客户跟进"
      width="45%"
      center
    >
      <el-table
        height="400px"
        border
        key="clientVal"
        ref="clientFollowRef"
        :data="clientFollowData.followInfo"
        @select="handleSelectionChangeFollow"
        :header-cell-style="{
          'text-align': 'center',
          background: '#edf3fe',
          color: '#0d6fb8',
        }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          prop="followContent"
          label="跟进内容"
          show-overflow-tooltip=""
        ></el-table-column>
        <el-table-column prop="intentionLevel" label="意向级别">
          <template slot-scope="{ row }">
            {{ getCurrentStage(row.intentionLevel, "intentionLevel") }}
          </template>
        </el-table-column>
        <el-table-column prop="workers" label="跟进人">
          <template slot-scope="{ row }">
            <!-- {{ row.workers }} -->
            {{ getWorkersVal(row.workers) }}
          </template>
        </el-table-column>
        <el-table-column prop="currentStage" label="跟进阶段">
          <template slot-scope="{ row }">
            {{ getCurrentStage(row.currentStage, "currentStage") }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleNext">下 一 步</el-button>
        <el-button @click="handleClearMasterId">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 跟进安排弹窗 -->
    <el-dialog
      :visible.sync="visibleFollowArrange"
      title="跟进安排"
      width="800px"
      center
    >
      <arrangeFollow
        ref="arrangeFollowRef"
        :clientInfo="clientAllData"
        :workersList="workersList"
        :masterId="masterId"
        @cancle="changeBtnShow"
        :currentBelong="queryParam.type"
      ></arrangeFollow>
      <div slot="footer" class="dialog-footer" v-if="isShowBtn">
        <el-button type="primary" @click="handleSaveFollow">保 存</el-button>
        <el-button @click="visibleFollowArrange = false">取 消</el-button>
      </div>
    </el-dialog>
    <worker-word
      :key="refreshWord"
      :word-type="wordType"
      :t-data="tData"
      :show="showWordDlg"
      @onWorkerWord="handleWord"
    ></worker-word>
  </div>
</template>
<style lang="scss" scoped>
.app-container {
  text-align: left !important;
}
.overflow-hidden {
  height: 500px;
  overflow-x: hidden;
}
.table-container {
  border: 0px;
}
.manage-btn {
  background-color: #fff;
  padding: 20px !important;
  text-align: right;
  box-sizing: border-box;
}
.tab-box {
  padding: 5px;
  background: #ecf3fd;
  display: flex;
  &-item {
    // margin-top: 1px;
    padding: 10px 36px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 10px;
    color: #74798c;
    &-checked {
      color: #ffffff;
      border-radius: 8px;
      background: #0e6fb8;
    }
  }
}
/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}

/deep/ .el-table .warning-row {
  background: #ec9898;
}

/deep/ .el-table .success-row {
  background: #54c019;
}
// /deep/ .el-table th.el-table__cell > .cell {
//   width: 90%;
//   height: auto;
//   background: #ecf3fd;
//   border-radius: 8px;
// }
// /deep/ .el-table__header-wrapper .cell {
//   line-height: 45px;
//   color: #0d6fb8;
// }
/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
  margin-top: 10vh !important;
}
/deep/.el-dialog {
  margin-top: 10vh !important;
}
/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}
</style>
<script>
import { qlUserChild } from "../../../api/userChild";
import commonUtils from "../../../utils/commonUtils";
import enumsUtil, {
  EAllIntention,
  EChildGender,
} from "../../../utils/enumsUtil";
import fileUpload from "@/components/Upload/fileUpload";
import { getToken } from "@/utils/auth";

import messageUtils from "../../../utils/messageUtils";
import globaldata from "../../../utils/globaldata";
import CreateCule from "../components/CreateCule";
import clientFollow from "./components/client-follow.vue";
import vipFollowVue from "./components/vip-follow.vue";
import dataImportFollow from "./components/data-import-follow.vue";
import arrangeFollow from "./components/follow-up-arrangement.vue";
import userChildDetail from "@/views/user_child/components/UserChildDetail";

import WorkerWord from "@/components/WorkerWord/WorkerWord";

import {
  adminFollowListGet,
  clientFollowDetailGet,
  clientAddFollow,
  adminFollowInfoGet,
  addFollowRecord,
  quantityFollowSwitchWorker,
  adminFollowWorkerInfo,
} from "@/api/PotentialCustomers";
import { adminJobPlanPlanWorksGET } from "@/api/vtwonewcontent";
import { adminStoreConfigGET, adminStoreConfigPUT } from "@/api/vtwonewcontent";
export default {
  components: {
    CreateCule,
    fileUpload,
    WorkerWord,
    clientFollow,
    vipFollowVue,
    dataImportFollow,
    arrangeFollow,
    userChildDetail,
  },
  data() {
    return {
      isShowBtn: true, //按钮是否显示
      refreshWord: "",
      showWordDlg: false,
      tData: null,
      wordType: 0,
      listLoading: true,
      //弹窗
      visibleDlgWord: false,
      visibleDlgAddClue: false,
      addRefresh: "",
      updateRefresh: "",
      refreshWord: "",
      queryParam: {
        type: 1,
        mobilePhone: undefined, //输入家长手机号
        childName: undefined, //输入会员孩子名
        childNickName: undefined, //孩子小名
        follower: undefined,
        usedClass:undefined,
        birthday: "", //生日
        //分页查询
        pageNum: 1, //当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      },
      allWorker: [],
      selectRow: null,

      createParam: {},
      //表单结果
      tableData: [],
      clueInfo: {},
      tabsList: [
        { name: "客户列表", type: 1 },
        { name: "会员跟进", type: 2 },
        { name: "数据导入", type: 3 },
      ],
      visibleParameterSetting: false, //参数设置弹窗
      settingForm: {}, //参数设置弹窗表单
      visibleFollow: false, //跟进弹窗
      visibleMoreFollow: false, //批量替换弹窗
      visibleClientFollow: false, //用户跟进信息弹窗
      visibleFollowArrange: false, //跟进安排弹窗
      moreFollowForm: {
        targetWorkerList: [
          {
            workerId: null,
          },
        ],
      }, //多个跟进弹窗表单
      moreFormRules: {
        // adName: {
        //   required: true,
        //   message: "此项不能为空",
        //   trigger: "blur",
        // },
      }, //多个跟进弹窗表单校验
      visibleFileupload: false, //营销数据导入弹窗
      isUploadBtn: true,
      workersList: [], //跟进人列表
      uploadUrl:
        process.env.BASE_API +
        `/admin/follow/dataImport/${globaldata.getAdminStore().storeFrontId}`,
      importHeaders: "",
      fileSuccessData: {},
      fileSuccessData: true,
      currentBthState: 0,
      selectionIds: [], //多个选中表格的id
      checkedId: null, //选中的id
      checkedData: {}, //当前行选中的数据
      clientFollowData: {}, //客户跟新信息数据
      masterId: null, //跟进人的id
      clientAllData: {},
      wordData: {}, //口令数据
      checkedWordData: {},
      isVip: globaldata.getAdminStore().isVip,
    };
  },
  created() {
    // globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    // this.flechList();
    // this.getList();
    this.adminJobPlanPlanWorksAxios();
  },
  mounted() {
    console.log(this.isVip, "globaldata.getAdminStore().storeFrontId");
    this.initData();
  },
  methods: {
    initData() {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      };
      this.doRefreshWord(true, 1, param);
    },
    //获取员工列表
    async adminJobPlanPlanWorksAxios() {
      const response = await adminJobPlanPlanWorksGET({
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      });
      if (response.code === 20000) {
        this.workersList = response.data;
      }
    },
    // 查询店铺配置
    async adminStoreConfigAxios() {
      const response = await adminStoreConfigGET({
        id: globaldata.getAdminStore().storeFrontId,
      });
      console.log("adminStoreConfigGET", response);
      const { data } = response;
      this.settingForm = data;
    },
    resetData() {
      this.moreFollowForm.targetWorkerList = [
        {
          workerId: null,
        },
      ];
      this.selectionIds = [];
      this.checkedId = null;
    },
    async getList() {
      this.listLoading = true;
      this.resetData();
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        pageNum: this.queryParam.pageNum, //当前第几页
        pageSize: this.queryParam.pageSize,
        type: this.queryParam.type,
        mobilePhone: this.queryParam.mobilePhone,
        childName: this.queryParam.childName,
        childNickName: this.queryParam.childNickName,
        follower: this.queryParam.follower,
        registerDate: this.queryParam.registerDate,
        usedClass: this.queryParam.usedClass,
        observer: this.wordData.id,
      };
      const res = await adminFollowListGet(param);
      console.log(res, "res");
      if (res.code === 20000) {
        this.listLoading = false;
        if (res.data.list && res.data.list.length) {
          // this.tableData = res.data.list;
          let list = res.data.list;
          let tableDataList = [];
          this.spanArr = [];
          this.pos = 0;
          for (let i = 0; i < list.length; ++i) {
            if (i === 0) {
              this.spanArr.push(1);
              this.pos = 0;
            } else {
              // 判断当前元素与上一个元素是否相同  inAccessCode（批次字段）
              if (list[i].userId === list[i - 1].userId) {
                this.spanArr[this.pos] += 1;
                this.spanArr.push(0);
              } else {
                this.spanArr.push(1);
                this.pos = i;
              }
            }
            let followInfo = {
              intentionLevel:
                list[i].followInfo && list[i].followInfo.intentionLevel
                  ? list[i].followInfo.intentionLevel
                  : null,
              workers:
                list[i].followInfo && list[i].followInfo.workers
                  ? list[i].followInfo.workers
                  : null,
              currentStage:
                list[i].followInfo && list[i].followInfo.currentStage
                  ? list[i].followInfo.currentStage
                  : null,
              followState:
                list[i].followInfo && list[i].followInfo.followState
                  ? list[i].followInfo.followState
                  : null,
              createDateTime:
                list[i].followInfo && list[i].followInfo.createDateTime
                  ? list[i].followInfo.createDateTime
                  : null,
            };
            let data = {
              ...followInfo,
              userId: list[i].userId,
              userName: list[i].userName,
              mobilePhone: list[i].mobilePhone,
              address: list[i].address,
              registerDate: list[i].registerDate,
              userRemark: list[i].userRemark,
              classMark: list[i].classMark,
              childName:list[i].children?list[i].children.childName:'',
              nickName:list[i].children? list[i].children.nickName:'',
              birthday:list[i].children? list[i].children.birthday:'',
              gender:list[i].children? list[i].children.gender == 0 ? "男" : "女":'',
              childId:list[i].children? list[i].children.childId:'',
              source:list[i].children? list[i].children.source:'',
              channel:list[i].children? list[i].children.channel:'',
            };
            tableDataList.push(data);
          }
          this.tableData = tableDataList;
        } else {
          this.tableData = [];
        }
        this.queryParam.totalPage = res.data.total;
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        columnIndex == 0 ||
        columnIndex == 1 ||
        columnIndex == 8 ||
        columnIndex == 9 ||
        columnIndex == 10 ||
        columnIndex == 11 ||
        columnIndex == 12 ||
        columnIndex == 13
      ) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    handleTab(type) {
      this.$set(this.queryParam, "type", type);
      this.getList();
    },
    // 参数设置按钮事件
    handleSetting() {
      this.adminStoreConfigAxios();
      this.visibleParameterSetting = true;
    },
    // 跟进按钮事件
    handleFollow() {
      // this.visibleFollow = true;
      let self = this;
      self.masterId = null;
      let checkedRus = self.getCheckedNumber();
      // if (!this.checkedId) return this.$message.warning("请先选择一条信息!");
      if (checkedRus) {
        self.currentBthState = 1;
        self.getClientFollowDetail();
      }
    },
    getCheckedNumber() {
      if (this.selectionIds.length > 1) {
        this.$message.warning("只能选择一条信息!");
        return false;
      } else if (this.selectionIds.length < 1) {
        this.$message.warning("请先选择一条信息!");
        return false;
      }
      this.checkedId = this.selectionIds[0];
      console.log(this.checkedId, "12121");
      return true;
    },
    // 客户跟新弹窗保存事件
    handleFollowSave() {
      // / this.$prompt的message前面加必填标志 *
      const h = this.$createElement;
      this.$prompt(
        h("p", null, [
          h("i", { style: "color: red" }, "* "),
          h("span", null, "输入口令"),
        ]),
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder: "请输入口令",
          // // 非空验证（正则）
          inputPattern: /^.+$/,
          inputErrorMessage: "口令内容不能为空",
          // callback:function(action, instance){
          //     if(action === 'confirm'){
          //         // do something...
          //         console.log(instance.inputValue);
          //     }
          // }
        }
      )
        .then(({ value }) => {
          console.log(value);
          this.checkedWord({
            storeFrontId: globaldata.getAdminStore().storeFrontId,
            adminWord: value,
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    async checkedWord(params) {
      const res = await adminFollowWorkerInfo(params);
      if (res.code == 20000) {
        this.checkedWordData = res.data;
        this.axiosAddFollowRecord();
      } else {
        return messageUtils.warningMsg(this, res.message);
      }
    },
    async axiosAddFollowRecord() {
      let params = {};
      if (this.queryParam.type == 1 || this.queryParam.type == 2) {
        params = {
          masterId: this.masterId,
          publisher: this.wordData.id,
          userId: this.checkedId,
          type: this.queryParam.type,
          followContent:
            this.$refs.clientPageFollowRef.clientForm.followInfo.followContent,
          feedbackResult:
            this.$refs.clientPageFollowRef.clientForm.followInfo.feedbackResult,
          currentStage:
            this.$refs.clientPageFollowRef.clientForm.followInfo.currentStage,
          intentionLevel:
            this.$refs.clientPageFollowRef.clientForm.followInfo.intentionLevel,
          feedbackAudio: this.$refs.clientPageFollowRef.audio,
          followWorkerId: this.checkedWordData.id,
          workers:
            this.$refs.clientPageFollowRef.clientForm.followInfo.workers.map(
              (item) => {
                if (item.workerId) {
                  return item.workerId;
                }
              }
            ),
        };
      } else if (this.queryParam.type == 3) {
        params = {
          publisher: this.wordData.id,
          userId: this.checkedId,
          type: this.queryParam.type,
          followContent: "客户跟进完善导入用户信息",
          currentStage: 9,
          intentionLevel: 1,
          followWorkerId: this.checkedWordData.id,
        };
      }
      console.log(params, "params11111");
      const res = await addFollowRecord(params);
      if (res.code == 20000) {
        this.clientAllData = {};
        this.$message.success(res.message);
        this.visibleFollow = false;
        this.handleResetSearch();
      }
    },
    // 跟进安排按钮事件
    handleFollowArrange() {
      let self = this;
      self.masterId = null;
      if (this.isVip == 0) return self.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      // if (!this.checkedId) return this.$message.warning("请先选择一条信息!");
      // this.visibleFollowArrange = true;

      let checkedRus = self.getCheckedNumber();
      if (checkedRus) {
        self.currentBthState = 2;
        self.getClientFollowDetail();
      }
    },
    getClientFollowDetail(type) {
      clientFollowDetailGet({
        type: this.queryParam.type,
        userId: this.checkedId,
        observer: this.wordData.id,
      }).then((res) => {
        if (res.code === 20000) {
          this.clientFollowData = res.data;
          if (res.data.followInfo && res.data.followInfo.length) {
            this.visibleClientFollow = true;
          } else {
            this.getFollowInfoAxios();
            if (this.currentBthState == 1) {
              this.visibleFollow = true;
            } else if (this.currentBthState == 2) {
              this.visibleFollowArrange = true;
            }
          }
        }
      });
    },
    handleOnBtnCreate(word) {
      this.visibleFollow = false;
      // this.getList();
      this.checkedWord({
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminWord: word,
      });
    },
    // 获取跟进安排详情信息
    async getFollowInfoAxios() {
      let params = {
        type: this.queryParam.type,
        userId: this.checkedId,
        masterId: this.masterId,
      };
      const res = await adminFollowInfoGet(params);
      if (res.code == 20000) {
        this.clientAllData = res.data;
      }
    },
    changeBtnShow(state) {
      console.log(state, "state");
      if (state == "second") {
        this.isShowBtn = false;
      } else {
        this.isShowBtn = true;
      }
    },
    handleSaveFollow() {
      let params = {
        masterId: this.masterId,
        type: this.queryParam.type,
        userId: this.checkedId,
        publisher: this.wordData.id,
        cardId:
          this.$refs.arrangeFollowRef.clientForm.followInfo &&
          this.$refs.arrangeFollowRef.clientForm.followInfo.card
            ? this.$refs.arrangeFollowRef.clientForm.followInfo.card.cardId
            : null,
        followContent:
          this.$refs.arrangeFollowRef.clientForm.followInfo.followContent,
        currentStage:
          this.$refs.arrangeFollowRef.clientForm.followInfo.currentStage,
        intentionLevel:
          this.$refs.arrangeFollowRef.clientForm.followInfo.intentionLevel,
        workers: this.$refs.arrangeFollowRef.clientForm.followInfo.workers.map(
          (item) => {
            return item.workerId;
          }
        ),
      };
      clientAddFollow(params).then((res) => {
        if (res.code == 20000) {
          this.visibleFollowArrange = false;
          this.$message.success(res.message);
          this.handleResetSearch();
        }
      });
    },
    // 批量替换按钮事件
    handleMoreFollow() {
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      if (!this.queryParam.follower)
        return this.$message.warning("请先筛选跟进人!");
      if (!this.selectionIds.length)
        return this.$message.warning("至少选择一条数据!");
      this.visibleMoreFollow = true;
    },
    //添加当前跟进人
    handleAddPerson() {
      let self = this;
      if (self.moreFollowForm.targetWorkerList.length) {
        try {
          self.moreFollowForm.targetWorkerList.forEach((item) => {
            if (!item.workerId) {
              self.$message.warning("请先选择当前跟进人");
              throw new Error("Something bad happened.");
            }
          });
        } catch (error) {
          if (error.message === "Something bad happened.") throw error;
        }
        self.moreFollowForm.targetWorkerList.push({ workerId: "" });
      } else {
        self.moreFollowForm.targetWorkerList.push({ workerId: "" });
      }
    },
    //删除当前跟进人
    handleDelPerson(index) {
      this.$delete(this.moreFollowForm.targetWorkerList, index);
    },
    // 批量替换弹窗保存事件
    handleMoreFollowSave() {
      this.visibleMoreFollow = false;

      this.axiosMoreSwitchWorker();
    },
    async axiosMoreSwitchWorker() {
      let params = {
        publisher: this.wordData.id,
        modifyUserId: this.selectionIds,
        type: this.queryParam.type,
        targetWorkerList: this.moreFollowForm.targetWorkerList.map(
          (item) => item.workerId
        ),
        replaceWorker: this.queryParam.follower,
      };
      const res = await quantityFollowSwitchWorker(params);
      console.log(res, "批量指定");
      if (res.code == 20000) {
        this.$message.success(res.message);
        this.handleResetSearch();
      }
    },
    // 营销数据导入事件
    handleFileUpload() {
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      let mytoken = getToken();
      this.importHeaders = { Authorization: mytoken };
      this.isUploadBtn = true;
      this.visibleFileupload = true;
    },
    //上传成功
    handleFileSuccess(response, file, fileList) {
      console.log(response, "response文件");
      let resultData = {
        url: response.data.url,
      };
      if (response.code == 20000) {
        this.fileSuccessData = response.data;
        this.isUploadBtn = false;
      } else {
        messageUtils.errorMsg(this, response.message);
      }
    },
    handleRefershFile() {
      this.visibleFileupload = false;
      this.$set(this.queryParam, "type", 3);
      this.getList();
    },
    handleSave() {
      adminStoreConfigPUT({
        id: globaldata.getAdminStore().storeFrontId,
        ...this.settingForm,
      }).then((res) => {
        if (res.code === 20000) {
          this.$message.success("参数设定保存成功");
          this.visibleParameterSetting = false;
        }
      });
    },
    handleSelectionChange(selection, val) {
      // if (selection.length > 1) {
      //   let del_row = selection.shift();
      //   this.$refs.clientTable.toggleRowSelection(del_row, false);
      // }
      // this.checkedData = selection[0];
      // console.log(this.checkedData, "行");
      // let checkedIds = selection.map((item) => item.userId);
      // this.checkedId = checkedIds[0];
      console.log(selection, "selection");
      this.checkedData = selection[0];
      let selectionIds = selection.map((item) => item.userId);
      this.selectionIds = selectionIds;
    },
    handleSelectionChangeFollow(selection, val) {
      if (selection.length > 1) {
        let del_row_child = selection.shift();
        this.$refs.clientFollowRef.toggleRowSelection(del_row_child, false);
      }
      let masterIds = selection.map((item) => item.masterId);
      this.masterId = masterIds[0];
    },
    handleNext() {
      // if (!this.masterId)
      //   return this.$message.warning("请先选择一条要跟进的信息!");
      if (this.queryParam.type == 2 && !this.masterId)
        return messageUtils.warningMsg(
          this,
          "暂不支持该操作,请前往会员管理添加!"
        );
      this.visibleClientFollow = false;
      this.getFollowInfoAxios();
      if (this.currentBthState == 1) {
        this.visibleFollow = true;
      } else if (this.currentBthState == 2) {
        this.visibleFollowArrange = true;
      }
    },
    getStoreWorkersInfo(workers) {
      this.allWorker = workers;
    },
    flechList() {
      this.listLoading = true;
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        name: this.queryParam.inputUserChild,
        petName: this.queryParam.inputChildNickName,
        userName: this.queryParam.inputUserName,
        userPhone: this.queryParam.inputPhone,
        pageNum: this.queryParam.pageNum, //当前第几页
        pageSize: this.queryParam.pageSize,
        usedClass: this.queryParam.usedClass,
      };
      qlUserChild(param).then((response) => {
        this.listLoading = false;
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.queryParam.totalPage = date.total;
        this.refreshData(date.list);
      });
    },
    //刷新页面数据
    refreshData(list) {
      if (commonUtils.isObjectNull(list)) {
        return;
      }
      let tableDataList = [];
      for (let i = 0; i < list.length; ++i) {
        let genderDes = EChildGender(list[i].gender);

        let childType = enumsUtil.childBodyType(list[i].childType);

        let data = {
          number: i + 1,
          id: list[i].id,
          userId: list[i].userId,
          userName: list[i].userName,
          phoneNumber: list[i].userPhone,
          childName: list[i].name,
          gender: list[i].gender,
          childGender: genderDes,
          childPetName: list[i].petName,
          childBirthday: list[i].birthday,
          areaAddress: list[i].areaAddress,
          childMonth: list[i].childMonth,
          childType: childType,
        };
        tableDataList.push(data);
      }
      this.tableData = tableDataList;
    },

    rowClick(row, column, event) {
      this.selectRow = row;
    },
    handleCheckSelect() {
      if (commonUtils.isObjectNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请先选择一条信息");
        return false;
      }
      return true;
    },
    // 重置按钮点击事件
    handleResetSearch() {
      this.$set(this.queryParam, "type", 1);
      this.$refs.queryForm.resetFields();
      this.onBtnSearch();
    },
    //点击查询按钮
    onBtnSearch() {
      this.getList();
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.classMark != 1) {
        return "warning-row";
      }
      return "";
    },

    /**
     * 添加线索
     */
    handleAddClueDig() {
      if (!this.handleCheckSelect()) {
        return;
      }

      this.clueInfo = {
        childId: this.selectRow.id,
        userId: this.selectRow.userId,
        childName: this.selectRow.childName,
        childPetName: this.selectRow.childPetName,
        userPhone: this.selectRow.phoneNumber,
      };
      this.visibleDlgAddClue = true;
    },

    onCreateClueSuccess() {
      this.visibleDlgAddClue = false;
    },

    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
      this.getList();
    },
    handleWord(wordType, tData) {
      if (wordType == 1) {
        this.doBuyExpCard(tData);
      }
    },
    doBuyExpCard(param) {
      adminFollowWorkerInfo(param).then((response) => {
        this.closeWordDlg();
        if (response.code == 20000) {
          this.wordData = response.data;
          this.getList();
        } else {
          messageUtils.errorMsg(this, response.message);
          this.initData();
        }
      });
    },
    doRefreshWord(show, wordType, tData) {
      this.tData = tData;
      this.wordType = wordType;

      this.showWordDlg = show;
      this.refreshWord = new Date().getTime();
    },
    closeWordDlg() {
      this.wordTitle = "";
      this.wordType = 0;
      this.showWordDlg = false;
      this.refreshWord = new Date().getTime();
    },
    getCurrentStage(val, type) {
      if (val) {
        switch (type) {
          case "intentionLevel":
            return val == 1
              ? "A+"
              : val == 2
              ? "A"
              : val == 3
              ? "B+"
              : val == 4
              ? "B"
              : val == 5
              ? "C"
              : val == 6
              ? "D"
              : "";
            break;
          // 当前阶段
          case "currentStage":
            return val == 1
              ? "建立联系"
              : val == 2
              ? "确认意向"
              : val == 3
              ? "承诺到访"
              : val == 4
              ? "预约试听"
              : val == 5
              ? "完成试听"
              : val == 6
              ? "完成缴费"
              : val == 7
              ? "放弃"
              : val == 8
              ? "童新跟进"
              : val == 9
              ? "完善客户信息"
              : val == 10
              ? "首次跟进"
              : val == 11
              ? "跟进中"
              : val == 12
              ? "跟进结果"
              : val == 13
              ? "跟进完成"
              : "";
            break;
          // 跟进阶段
          case "followState":
            return val == 1 ? "短期跟进" : val == 2 ? "长期跟进" : "";
        }
      } else {
        return "";
      }
    },
    getWorkersVal(val) {
      let str = "";
      if (val && val.length) {
        if (val.length > 1) {
          val.forEach((element) => {
            str += element.workerName + "、";
          });
        } else if (val.length == 1) {
          val.forEach((element) => {
            str += element.workerName + "";
          });
        }

        return str;
      } else {
        return str;
      }
    },
    handleClearMasterId() {
      this.visibleClientFollow = false;
      this.masterId = null;
    },
    handleDownload() {
      let fileUrl =
        "https://ossmeng.yyinhong.cn/common/template/%E5%AE%A2%E6%88%B7%E8%B7%9F%E8%BF%9B%E6%95%B0%E6%8D%AE%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";
      window.open(fileUrl);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/marketing-manager/potential-customers/index.vue